// Types for Memory Health system

export enum AssetHealthStatus {
  HEALTHY = "healthy",
  PROCESSING = "processing",
  VERSION_MISMATCH = "version_mismatch",
  MISSING_IN_MEMORY = "missing",
  NEEDS_REBUILD = "needs_rebuild",
  NOT_PUBLISHED = "not_published",
  DELETED = "deleted",
  CRASHED = "crashed",
  SCHEMA_OUTDATED = "schema_outdated",
  ERROR = "error",
}

export interface AssetHealthInfo {
  asset_id: string;
  namespace: string;
  db_version: number;
  published_version: number;
  stable_version: number;
  schema_version: string | null;
  status: AssetHealthStatus;
  deleted: boolean;
  error_message?: string;
  crash_details?: {
    transaction_index: number;
    type: string;
    major_version: number;
    namespace: string;
  };
  last_modified: string;
}

export interface NamespaceHealthSummary {
  namespace: string;
  total_assets: number;
  healthy_count: number;
  needs_rebuild_count: number;
  not_published_count: number;
  deleted_count: number;
  error_count: number;
  assets: AssetHealthInfo[];
}

export interface MemoryIntegrityCheck {
  namespace: string;
  has_crashes: boolean;
  crash_details?: any;
  graph_exists: boolean;
  transaction_index?: number;
  processed_clocks: number;
  memory_ready: boolean;
  schema_version?: string;
  errors: string[];
}

export interface RebuildRequest {
  namespace: string;
  asset_ids?: string[];
  rebuild_all?: boolean;
}

export interface RebuildResponse {
  success: boolean;
  message: string;
  task_id?: string;
}

// Namespace health summary types
export interface NamespaceSummary {
  namespace: string;
  total_assets: number;
  healthy_count: number;
  processing_count?: number;
  version_mismatch_count?: number;
  missing_count?: number;
  needs_rebuild_count: number;
  not_published_count: number;
  deleted_count: number;
  crashed_count?: number;
  schema_outdated_count?: number;
  error_count: number;
  is_stable: boolean;
}

export interface NamespacePair {
  base_name: string;
  dev_namespace: string;
  stable_namespace?: string;
  dev_stats?: NamespaceSummary;
  stable_stats?: NamespaceSummary;
  needs_stable_update?: boolean;
}

export interface AllNamespacesHealthResponse {
  namespaces: NamespaceSummary[];
  namespace_pairs?: NamespacePair[];
  total_namespaces: number;
  checked_at: string;
}
